import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useResize from '@/hooks/useResize';
import About from './About';
import Contact from './Contact';
import { GoTop } from '../style';
import Footer from '../Footer';
import StrategicPartners from '../StrategicPartners';
import { Helmet } from 'react-helmet';
import LocalizedPageLinks from '@/components/SEO/LocalizedPageLinks';

const AboutUs = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isTablet, isMobile } = useResize();

  useEffect(() => {
    // 取得網址的#後面的字串
    const hash = window.location.hash;
    // 如果有hash值，就滾動到該元素
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  return (
    <div>
      <Helmet>
        <title>{t('seo.about.title')}</title>
        <meta itemProp="name" content={t('seo.about.title')} />
        <meta property="og:title" content={t('seo.about.title')} />
        <meta name="twitter:title" content={t('seo.about.title')} />
        <meta name="description" content={t('seo.about.metaDescription')} />
        <meta property="og:description" content={t('seo.about.metaDescription')} />
        <meta name="twitter:description" content={t('seo.about.metaDescription')} />
      </Helmet>
      <LocalizedPageLinks pagePath="/About" />
      <About />
      <StrategicPartners />
      <Contact />
      {/* <Message /> */}
      <Footer />
      <GoTop
        isTablet={isTablet}
        isMobile={isMobile}
        onClick={() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        {t('top')}
      </GoTop>
    </div>
  );
};

export default AboutUs;
